// check users and replace with items
// confirm status column value in the list to display

import React, { Component } from 'react';
import InfiniteScroll from "react-infinite-scroll-component";
import { withRouter, Link } from 'react-router-dom';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { debounce } from 'lodash';

import { getVendorProductList, searchVendorProduct } from '../../Redux/Actions/vendorAction';

class Vendor_Product_List extends Component {

    vendorId = "";

    constructor(props) {
        super(props);
        this.state = {
            maxLimit: 10,
            offset: 0,
            prevOffset: 0,
            items: [],
            searchKeyword: "",
            hasMore: true,
            showLoader: false
        };
    }

    componentDidMount() {
        this.vendorId = this.props.match.params.vendorId;
        this.fetchMoreData(true);
    }

    componentWillReceiveProps(nextProps) {
        // You don't have to do this check first, but it can help prevent an unneeded render
        if (nextProps.match.params.vendorId !== this.props.match.params.vendorId) {
            this.vendorId = nextProps.match.params.vendorId;
            this.fetchMoreData(true);
        }
    }

    fetchMoreData = async (firstLoad) => {
        this.setState({
            showLoader: true
        })
        if (this.state.offset !== this.state.prevOffset || firstLoad) {
            if (this.state.hasMore && this.state.maxLimit && (this.state.maxLimit === "all" || this.state.maxLimit > this.state.offset)) {
                let result;
                if (this.state.searchKeyword && this.state.searchKeyword.length > 0) {
                    result = await this.props.searchVendorProduct(this.state.offset, this.vendorId, this.state.searchKeyword.trim());
                }
                else {
                    result = await this.props.getVendorProductList(this.vendorId, this.state.offset);
                }

                // let result = await this.props.getUsersList(this.state.offset);
                if (result ?.data ?.data ?.length > 0) {
                    this.setState(prevState => {
                        return {
                            ...prevState,
                            prevOffset: prevState.offset,
                            offset: prevState.offset + 10,
                            items: prevState.items.concat(result.data.data),
                            showLoader: false
                        }
                    })
                }
                else {
                    this.setState({ hasMore: false, showLoader: false });
                }
            } else {
                this.setState({
                    showLoader: false
                })
            }
        } else {
            this.setState({
                showLoader: false
            })
        }
    };

    handleChange = async (event, field) => {
        event.preventDefault();
        // console.log("event value is", +event.target.value);

        if (field === "maxLimit") {
            await this.setState({
                [field]: event.target.value === "all" ? event.target.value : +event.target.value
            })
            this.fetchMoreData(false);
        }
        else {
            await this.setState({
                [field]: event.target.value,
                offset: 0,
                prevOffset: 0,
                hasMore: true
            })

            this.debounceSearchCall();
        }
    };

    debounceSearchCall = debounce(() => {
        this.setState({
            items: []
        })
        this.fetchMoreData(true);
    }, 1000);

    render() {
        console.log("this.state.items is", this.state.items);

        const itemsList = this.state.items.map(i => {
            let viewProductPath = `https://subsciety.azurewebsites.net/product/${i.slug}`;
            viewProductPath = i.status && i.status == 'pending' || i.isActive !== 1 ? `${viewProductPath}?preview` : viewProductPath;
            return (
                <tr key={i.id}>
                    <td align="center">{i.id ? i.id : "-"}</td>
                    <td>{i.name ? i.name : "-"}</td>
                    <td>{i.price ? `$${i.price}` : "-"}</td>
                    {/* <td>1</td> */}
                    <td>{i.isActive === 1 ? "Yes" : "No"}</td>
                    <td>
                        <p class="orange">{i.status && i.status !== '' ? i.status : "-"}</p>
                    </td>
                    <td align="center">
                        <div class="vendor-table-btn">
                            <Link to={{ pathname: viewProductPath }} target="_blank">
                                <button type="button" class="orange-outline-btn">View</button>
                            </Link>

                            <Link to={`/vendors/product/${this.vendorId}/edit/${i.slug}`}>
                                <button type="button" class="orange-outline-btn">Edit</button>
                            </Link>


                            {/* <button type="button" class="orange-outline-btn">
                                <Link to={{ pathname: `https://subsciety.azurewebsites.net/product/${i.slug}` }} target="_blank">View</Link>
                            </button> */}
                            {/* <button type="button" class="orange-outline-btn">
                                <Link to={`edit-product/${i.slug}`}>Edit</Link>
                            </button> */}
                        </div>
                    </td>
                </tr>
            )
        });

        return (
            <div class="admin-card">
                <div class="admin-card-head">
                    <h2>{this.props ?.location ?.vendorFirstname ? this.props.location.vendorFirstname : null} {this.props ?.location ?.vendorLastname ? this.props.location.vendorLastname : null} Product list</h2>
                    {/* <Link to={'/add-product'}>
                        <button type="text" class="orange-outline-btn">
                            <i class="fas fa-plus"></i> Add Product
                        </button>
                    </Link> */}
                </div>
                <div class="admin-card-box">
                    <div class="vendor-table">

                        <div class="vendor-table-head">
                            <div class="row">
                                <div class="col-lg-4 col-md-4">
                                    <div class="entries-drop">
                                        <label>show</label>
                                        <select class="entries-controls" onChange={(e) => this.handleChange(e, "maxLimit")} value={this.state.maxLimit}>
                                            <option value="10">10</option>
                                            <option value="20">20</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                            <option value="all">All</option>
                                        </select>
                                        <p>Entries</p>
                                    </div>
                                </div>
                                <div class="col-lg-8 col-md-8">
                                    <div class="vendor-table-head-right">
                                        <div class="vendor-table-search">
                                            <input class="form-control" onChange={(e) => this.handleChange(e, "searchKeyword")} value={this.state.searchKeyword} type="text" placeholder="search" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="vendor-table-body">
                            <div class="table-responsive">
                                <InfiniteScroll
                                    dataLength={this.state.items.length}
                                    next={() => this.fetchMoreData(false)}
                                    hasMore={this.state.hasMore}
                                >
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <td align="center">#</td>
                                                <td>title</td>
                                                <td>price</td>
                                                {/* <td>sales</td> */}
                                                <td>active</td>
                                                <td>status</td>
                                                <td align="center">action</td>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {itemsList.length > 0 ? itemsList : "No products for this vendor"}

                                            {/* <tr>
                                            <td align="center">5420</td>
                                            <td>Loren ipsum dolor</td>
                                            <td>$499.00</td>
                                            <td>1</td>
                                            <td>
                                                <p class="orange">pending</p>
                                            </td>
                                            <td align="center">
                                                <div class="vendor-table-btn">
                                                    <button type="button" class="orange-outline-btn">View</button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">5420</td>
                                            <td>Loren ipsum dolor</td>
                                            <td>$499.00</td>
                                            <td>1</td>
                                            <td>
                                                <p class="black">published</p>
                                            </td>
                                            <td align="center">
                                                <div class="vendor-table-btn">
                                                    <button type="button" class="orange-outline-btn">View</button>
                                                </div>
                                            </td>
                                        </tr> */}

                                        </tbody>

                                    </table>
                                </InfiniteScroll>
                                {this.state.showLoader ? (
                                    <div class="d-flex justify-content-center">
                                        <div class="spinner-border" role="status">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                    </div>
                                ) : (null)}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ getVendorProductList, searchVendorProduct }, dispatch);
}

export default withRouter(connect(null, mapDispatchToProps)(Vendor_Product_List))
